<template>
  <div :class="(isOdd ? 'dark ' : '') + (isRefunded ? 'refunded ' : '') + (isRefund ? 'refund ' : '') + (isOpenOrder ? 'open ' : '') + (isConfirmedOrder ? 'confirmed ' : '') + 'transaction-row transaction-list-item'" v-on:click="transactionClicked">
    <div class="transaction-details">
      <div class="transaction-id">
        <strong>{{ transaction.id }}</strong>
      </div>
      <div class="transaction-name-date">
        <div class="transaction-date">{{ $filters.timestampToDate(displayedDate, locale) }} {{ _('at') }} {{ $filters.timestampToTime(displayedDate, locale) }}</div>
        <div class="transaction-name">{{ transactionName }}</div>
      </div>
    </div>
    <div class="transaction-info">
      <button v-if="transaction.more || transaction.notes" type="button" class="btn btn-xs btn-info" v-on:click.prevent.stop="notesClicked()"><i class="fa fa-fw fa-sticky-note"></i></button>
    </div>
    <div class="transaction-price">
      {{ $filters.currency(transaction.totalWithDelivery, 'EUR') }}
    </div>
  </div>  
</template>

<style>
/*
.transaction-list-item {
  padding: 5px;
}
.transaction-list-item div {
  white-space: nowrap;
  overflow: hidden;
}
*/
.transaction-list-item:hover {
  cursor: pointer;
}
.transaction-info {
  flex: 1;
}
.dark {
  background-color: #ECEFF1;
}
</style>

<script>

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['locale']),
    isOdd () {
      return this.index % 2
    },
    transactionName () {
      return this.transaction.name || 'Johku App'
    },
    isRefunded () {
      if (parseInt (this.transaction.refunded)) {
        return true
      }
    },
    isOpenOrder () {
      return this.transaction.payment === 'open' && !this.isConfirmedOrder
    },
    isConfirmedOrder () {
      return parseInt(this.transaction.confirmed)  && !this.isPaid
    },
    isPaid () {
      return parseInt(this.transaction.paid)
    },
    isRefund () {
      if (parseInt (this.transaction.isrefund)) {
        return true
      }
    },
    displayedDate () {
      if (!this.transaction) {
        return null
      }
      if (this.transaction.invoicedate) {
        return this.transaction.invoicedate
      }
      return this.transaction.orderdate
    }
  },
  props: ['transaction', 'baseDomain', 'index'],
  methods: {
    transactionClicked () {
      this.$emit('transactionClicked', this.transaction)
    },
    notesClicked () {
      this.$emit('notesClicked', this.transaction)
    }
  }
}

</script>